import TabPanel from "./TabPanel";
import React, { useState } from "react";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Collapse from "@mui/material/Collapse";

import { RowDetail, Meta, DataBlock, Label, OverflowText, StyledAppBar } from "./styles";
import Player from "../../components/Player";

const showValue = (val) => {
  if (!val) {
    return <em> null </em>;
  }
  return val;
};

function DetailedTransaction({ expandedRows, row }) {
  const [tab, setTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const parseJSON = (jsonStr) => {
    let value;
    try {
      value = JSON.parse(jsonStr);
    } catch (err) {
      console.error(`Unable to parse JSON: ${jsonStr}`);
    }

    return value || jsonStr;
  };

  return (
    <Box>
      <Collapse in={expandedRows.has(row.requestUuid)} timeout="auto" unmountOnExit>
        <RowDetail>
          <StyledAppBar position="static">
            <Tabs value={tab} onChange={handleTabChange} aria-label="simple tabs example">
              <Tab label="Metadata" />
              <Tab label="Content Context" />
              {row?.intentResponse && <Tab label="Intent Response" />}
            </Tabs>
          </StyledAppBar>
          <TabPanel value={tab} index={0}>
            <Meta>
              <DataBlock className="short">
                <div className="header">Audio</div>
                <div className="row">
                  {row?.audioBytes && (
                    <>
                      <div className="label">Bytes</div>
                      <div className="value">{row?.audioBytes}</div>
                    </>
                  )}
                </div>
                <div className="row">
                  {row?.audioDurationMs && (
                    <>
                      <div className="label">Duration</div>
                      <div className="value">{row?.audioDurationMs} ms</div>
                    </>
                  )}
                </div>
              </DataBlock>
              <DataBlock>
                <div className="header">Timings</div>
                <div className="row">
                  <div className="label long">Entire Transaction</div>
                  <div className="value">{row?.entireTransactionMs || "0"} ms</div>
                </div>
                <div className="row">
                  <div className="label long">Intent Detection</div>
                  <div className="value">{row?.intentDetectionMs || "0"} ms</div>
                </div>
              </DataBlock>
              <DataBlock>
                <div className="header">Vocera</div>
                <div className="row">
                  <div className="label">Session ID</div>
                  <div className="value">{showValue(row?.voceraSessionId)}</div>
                </div>
                <div className="row">
                  <div className="label">Facility</div>
                  <div className="value">{showValue(row?.voceraFacilityId)}</div>
                </div>
              </DataBlock>
            </Meta>
          </TabPanel>

          <TabPanel value={tab} index={1}>
            {row?.inputClientContext && (
              <>
                <Label>Input Client Context </Label>
                <OverflowText>
                  <pre>{JSON.stringify(parseJSON(row?.inputClientContext), null, 2)}</pre>
                </OverflowText>
              </>
            )}
            {row?.inputIntentContext && (
              <>
                <Label>Input Intent Context </Label>
                <OverflowText>
                  <pre>{JSON.stringify(parseJSON(row?.inputIntentContext), null, 2)}</pre>
                </OverflowText>
              </>
            )}
          </TabPanel>
          {row?.intentResponse && (
            <TabPanel value={tab} index={2}>
              <>
                <Label>Intent Response </Label>
                <OverflowText>
                  <pre>{JSON.stringify(parseJSON(row?.intentResponse), null, 2)}</pre>
                </OverflowText>
              </>
            </TabPanel>
          )}
          {row?.audiofilePath && <Player src={row?.audiofilePath} />}
        </RowDetail>
      </Collapse>
    </Box>
  );
}

export default DetailedTransaction;
